export const createIsLinkActive = (currentPath: string) => (path: string) => path === currentPath;
